import React from 'react';

const LINE_STYLE = { display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600 };

function BarRow({ label, value, trailing, width, color, dotColor }) {
  return (
    <div>
      <div style={LINE_STYLE}>
        {dotColor && <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />}
        <span style={{ flex: 1, minWidth: 0, color: 'var(--sl-text-secondary)' }}>{label}</span>
        <span style={{ color: 'var(--sl-text-primary)' }}>{value}</span>
        {trailing}
      </div>
      <div style={{ margin: `6px 0 0 ${dotColor ? 16 : 0}px`, height: 6, borderRadius: 3, background: 'var(--sl-bg-tertiary)', overflow: 'hidden' }}>
        <div style={{ width: `${width}%`, height: '100%', borderRadius: 3, background: color }} />
      </div>
    </div>
  );
}

export default BarRow;
